import util from '../util'

const base= window.$servicePath;

export default {

  listFlowDocument(...arg) {
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.listFlowDocument`, ...arg);
  },

  listCommentByBatch(...arg) {
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.listCommentByBatch`, ...arg);
  },

  addComment(...arg) {
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.addComment`, ...arg)
  },
  updateComment(...arg) {
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.updateComment`, ...arg)
  },
  deleteComment(...arg) {
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.deleteComment`, ...arg)
  },
  getFlowProcess(...arg) {
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.getFlowProcess`, ...arg)
  },

  listUnfinishedTask(...arg) {
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.listUnfinishedTask`, ...arg)
  },

  listTaskTransactor(...arg) {
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.listTaskTransactor`, ...arg)
  },

  getNextFlows(...arg) {
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.getNextFlows`, ...arg)
  },

  getFlowGroupUserOrPositions(...arg) {
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.getFlowGroupUserOrPositions`, ...arg)
  },

  forceComplete(...arg) {
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.forceComplete`, ...arg)
  },

  replaceTaskIdentity(...arg) {
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.replaceTaskIdentity`, ...arg)
  },

  suspendProcess(...arg) {
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.suspendProcess`, ...arg)
  },
  listFlowSuspend(...arg) {
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.listFlowSuspend`, ...arg)
  },
  activeDocument(...arg){
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.activeDocument`, ...arg)
  },
  deleteDocument(...arg){
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.deleteDocument`, ...arg)
  },
  forceWithdraw(...arg) {
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.forceWithdraw`, ...arg)
  },

  getNormalTaskActivities(...arg) {
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.getNormalTaskActivities`, ...arg)
  },

  terminateProcess(...arg) {
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.terminateProcess`, ...arg)
  },

  toVoidDocument(...arg) {
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.toVoidDocument`, ...arg)
  },

  listTransactionLog(...arg) {
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.listTransactionLog`, ...arg)
  },
  getTransactionLog(...arg) {
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.getTransactionLog`, ...arg)
  },
  expFlowTransLog(params){
    return util.downloadAttachment(`${base}/api/maintain/expFlowTransLog`,params);
  },
  updateAndReExecute(...arg) {
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.updateAndReExecute`, ...arg)
  },
  reExecute(...arg) {
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.reExecute`, ...arg)
  },
  batchReExecute(...arg) {
    return util.ajax(`${base_process_intervene}batchReExecute`, ...arg)
  },
  specify(...arg) {
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.specify`, ...arg)
  },

  startSubProcess(...arg) {
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.startSubProcess`, ...arg)
  },

  addTask(...arg) {
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.addTask`, ...arg)
  },
  deleteTask(...arg){
    return util.ajax(`${base}/cheetah/service/s:pintervene.srv.deleteTask`, ...arg)
  },

  getHiddenFormData(...arg) {
    return util.ajax(`${base}/cheetah/service/s:maintain.srv.getHiddenFormData`, ...arg);
  },
  listAuthority(...arg) {
    return util.ajax(`${base}/cheetah/service/s:maintain.srv.listAuthority`, ...arg);
  },
  deleteAuthority(...arg) {
    return util.ajax(`${base}/cheetah/service/s:maintain.srv.deleteAuthority`, ...arg);
  },
  coverAuthority(...arg) {
    return util.ajax(`${base}/cheetah/service/s:maintain.srv.coverAuthority`, ...arg);
  },
  listOrgRes(...arg) {
    return util.ajax(`${base}/cheetah/service/s:maintain.srv.listOrgRes`, ...arg);
  },
  listOrgDetail(...arg) {
    return util.ajax(`${base}/cheetah/service/s:maintain.srv.listOrgDetail`, ...arg);
  },
  //表数据管理
  updateFormData(...arg) {
    return util.ajax(`${base}/cheetah/service/s:maintain.srv.updateFormData`, ...arg);
  },
  saveFormData(...arg) {
    return util.ajax(`${base}/cheetah/service/s:maintain.srv.saveFormData`, ...arg);
  },
  listTableTree(...arg){
    return util.ajax(`${base}/cheetah/service/s:maintain.srv.listTableTree`, ...arg)
  },
  listTableInfo(...arg){
    return util.ajax(`${base}/cheetah/service/s:maintain.srv.listTableInfo`, ...arg)
  },
  importTableData(...arg){
     return util.ajax(`${base}/cheetah/service/s:maintain.srv.importTableData`, ...arg)
  },
  /*exportTableData(...arg){
    return util.ajax(`${base}/cheetah/service/s:maintain.srv.exportTableData`, ...arg)
  },*/
  exportSqlTableData(data) {
    let params = {};
    let json = PF.encode({ data: data });
    return util.downloadAttachment(`${base}/api/maintain/exportSqlTableData`, params, undefined, json, true);
  },
}



// WEBPACK FOOTER //
// ./src/common/api/maintain.js